<script>
    import R, {LOADER} from "../lib/requests";
    import {formatDate} from "../lib/lib";
    import PageHeader from "../components/PageHeader.svelte";
    import TableHeader from "../components/TableHeader.svelte";
    import DateControl from "../components/controls/DateControl.svelte";
    import Pagination from "../components/Pagination.svelte";

    const tableColumns = [
        {key: 'created_at', title: 'DATE', sortable: true, sort_way: 'DESC'},
        {key: 'message', title: 'MESSAGE'},
        {key: 'mobiles', title: 'MOBILES'},
        {key: 'total_mobiles', title: 'RECIP.', sortable: true},
    ];

    let search = {
        limit: 100,
        offset: 0,
        date_from: '',
        date_to: '',
    }

    let list = null;
    let total_sms = 0;
    let total_recipients = 0;
    let page = 1;

    const load = () => {
        const onSuccess = result => {
            list = result.list;
            total_sms = result.total_sms;
            total_recipients = result.total_recipients;

            list.map(item => {
                item.created_at = formatDate(item.created_at, 'd-m-y H:i');
            });
        }

        const onFailure = err => {
        };

        search.offset = (page - 1) * search.limit;

        R.handle(R.sms.index, search, onSuccess, onFailure, LOADER.PAGE);
    }

    const onPageChange = ({detail}) => {
        page = detail;
        load();
    }

    const onColumnSort = ({detail}) => {
        search.sort_field = detail.key;
        search.sort_way = detail.sort_way;
        load();
    }

    const onSearch = () => {
        page = 1;
        load();
    }

    load();
</script>

<PageHeader title="Sms Report"/>

<div class="panel-simple p-2 mb-4">
    <div class="row">
        <div class="col-md-2 col-6">
            <DateControl placeholder="from" bind:value="{ search.date_from }"/>
        </div>
        <div class="col-md-2 col-6 form-group-sm">
            <DateControl placeholder="to" bind:value="{ search.date_to }"/>
        </div>
        <div class="col-md-6"></div>
        <div class="col-md-2 col-12">
            <button class="btn btn-outline btn-block" on:click="{ onSearch }">SEARCH</button>
        </div>
    </div>
</div>

{#if list}
    <table class="table table-list table-list-border table-sm mb-4">
        <TableHeader {tableColumns} on:sort={onColumnSort}/>
        <tbody>
        {#each list as item}
            <tr>
                <td class="datetime-column">{ item.created_at }</td>
                <td>{ item.message }</td>
                <td>{ item.mobiles }</td>
                <td class="numeric-column text-end">{ item.total_mobiles }</td>
            </tr>
        {/each}
        <tr>
            <td colspan="3" class="fw-bold">Total Recipients</td>
            <td class="text-end fw-bold">{ total_recipients }</td>
        </tr>
        </tbody>
    </table>
    <Pagination itemsPerPage="{ search.limit }" totalItems="{ total_sms }"
                page="{ page }"
                on:change="{ onPageChange }"/>
{/if}